import { Dispatch, SetStateAction } from 'react';
import { ProjectsResponse, Subproject } from '../api/projects-client/projects-client.type';

enum WorkPeriodType {
  Flexible = 'Flexible',
  Sprint = 'Sprint',
}

type FlexibleWorkPeriod = {
  start: Date | null;
  end: Date | null;
};

type GlobalFilterContextType = {
  team: ProjectsResponse | null;
  setTeam: Dispatch<SetStateAction<ProjectsResponse | null>>;
  workPeriodType: WorkPeriodType;
  setWorkPeriodType: Dispatch<SetStateAction<WorkPeriodType>>;
  board: Subproject | null;
  setBoard: Dispatch<SetStateAction<Subproject | null>>;
  sprint: string | null;
  setSprint: Dispatch<SetStateAction<string | null>>;
  flexibleWorkPeriod: FlexibleWorkPeriod;
  setFlexibleWorkPeriod: Dispatch<SetStateAction<FlexibleWorkPeriod>>;
};

export { WorkPeriodType };
export type { FlexibleWorkPeriod, GlobalFilterContextType };
